import { Either, isLeft, isRight, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import HumanAgentEntity from "../../../../domain/entities/human_agent.entity";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const createHumanAgentApiImpl = async (agent: HumanAgentEntity): Promise<Either<ErrorEntity, HumanAgentEntity>> => {
    try {
        const relativeUrl = "/human-agent";
        if (agent.name == null || agent.name?.length == 0 || agent.agentId == null || agent.agentId?.length == 0) {
            return left({ code: KeyWordLocalization.ErrorHostMissingField });
        }
        const body = {
            "name": agent.name,
            "internal_id": agent.agentId,
        };
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, body, {
            contentType: "application/json",
        });

        return right(agent);



    } catch (error) {

        const errorEntity = ErrorEntity.fromError(error);
        if (errorEntity.code != KeyWordLocalization.ErrorHostundefined) return left(errorEntity);

        if (errorEntity.message?.includes("Duplicate entry")) {
            return left({ code: KeyWordLocalization.ErrorHostDuplicatedHuman });
        }
        if (errorEntity.message?.includes("missing")) {
            return left({ code: KeyWordLocalization.ErrorHostMissingField });
        }
        else {
            return left({ code: KeyWordLocalization.ErrorHostCreateHuman });
        }
    }
};

export default createHumanAgentApiImpl;